<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            style="height: 100%"
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <div class="carInsBtn">
              <el-row>
                <el-col class="carInsHeadLeft" :span="12">
                  <span>{{ $t("PlatformSettings.brandManagement") }}</span>
                </el-col>
                <el-col class="carInsHeadRight" :span="12">
                  <span>
                    <i
                      v-if="isPrimaryKey('DICTIONARYMANAGEMENT_BRANDADD')"
                      @click="addBrand"
                      style="cursor: pointer"
                      class="el-icon-plus"
                    ></i>
                    <i
                      v-if="isPrimaryKey('DICTIONARYMANAGEMENT_BRANDEDIT')"
                      @click="editBrand"
                      style="cursor: pointer"
                      class="el-icon-edit"
                    ></i>
                    <i
                      v-if="isPrimaryKey('DICTIONARYMANAGEMENT_BRANDDELETE')"
                      @click="deleteBrand"
                      style="cursor: pointer"
                      class="el-icon-delete"
                    ></i>
                  </span>
                </el-col>
              </el-row>
            </div>
            <div class="carInsList">
              <el-scrollbar>
                <el-radio-group
                  @change="ChangModel"
                  style="width: 100%"
                  v-model="brandId"
                >
                  <el-radio
                    v-for="item in BrandList"
                    :key="item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-scrollbar>
            </div>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('DICTIONARYMANAGEMENT_TYPEEDIT')"
                  type="text"
                  :disabled="selected.length == 0"
                  @click="editModel"
                  >{{ $t("common.btn.edit") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('DICTIONARYMANAGEMENT_TYPEDELETE')"
                  type="text"
                  :disabled="selected.length == 0"
                  @click="deleteModel"
                  >{{ $t("common.btn.delete") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('DICTIONARYMANAGEMENT_TYPEADD')"
                  type="text"
                  @click="addModel"
                  >{{ $t("common.btn.add") }}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="name"
            :label="$t('PlatformSettings.brandName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="brandSort"
            :label="$t('TerminalCommand.sort') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.brandSort"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeModelDia"
        class="addDialong"
        :title="diaModelTitle"
        :visible.sync="dialogModelFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="ModelRules" ref="ModelForm" :model="ModelForm">
          <el-form-item
            prop="name"
            :label="$t('PlatformSettings.type') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="ModelForm.name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="remarks"
            :label="$t('common.remark') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="ModelForm.remarks"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleModel('ModelForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="submitModelForm('ModelForm')"
            >{{ $t("common.btn.confirm") }}</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import dictionaryManagement from "./dictionaryManagement.js";
export default dictionaryManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
